const navigatorDetect = () => {
  if (navigator.userAgent.match(/Android/)) {
    if (navigator.userAgent.match(/Chrome/)) {
      return 'AndroidChrome';
    }
    return 'Android';
  }
  if (navigator.userAgent.match(/iPhone|iPad|iPod/)) {
    return 'Apple';
  }
  return null;
};

export default navigatorDetect;
